import _ from "lodash";

export function getMainAppURL() {
    const authAppURL = _.get(process.env, 'VUE_APP_MAIN_APP_URL', null)

    if (authAppURL === null) {
        return '/'
    }

    return authAppURL
}

export function getBaseApiURL() {
    return process.env.NODE_ENV === 'production'
        ? '/api/'
        : '/'
}
